import React, { useState, useEffect } from 'react'
import s from './GeoentityBlockContentWidget.less'
import useCommonGeoentityClickTagProps from '../useCommonGeoentityClickTagProps'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { getFutureDateISO } from '../../utils/date'
import { populateGeoentityUrl } from '../../utils/geoentity'
import classNames from 'classnames'
import { requestGeoentityContentWidget } from '../../../dataSource/geoentity/geoentity.requests'
import { useSelector } from 'react-redux'
import {
  selectGeoentityCurrentTabId,
  selectFilterHotelDates,
  selectCurrentGeoentityId
} from '../../../store/geoentity/geoentity.selectors'
import { CONFIG_TYPES, getMatchingConfig } from '../../../store/poiassets/poiassets.selectors'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import { SPD_GEOENTITY_LINK } from '../../analytics/BiTagger'
import replacePropertyValueDeep from '../../utils/replacePropertyValueDeep'
import DatesPickerHotel from '../../genericComponents/datesPickerHotel/DatesPickerHotel'
import RectangleActionButton, { COLOR_ORANGE_EMPTY } from '../../genericComponents/buttons/RectangleActionButton'
import { debounce } from '../../../utils/function'

const updateRooms = debounce((options, setWidgetData) => {
  requestGeoentityContentWidget(options)
    .then(result => replacePropertyValueDeep(result, { reservationUrl: populateGeoentityUrl }))
    .then(result => setWidgetData(result))
}, 300)

export const PeopleForm = ({ people = 2, onChange }) => {
  const morePeople = () => {
    if (people >= 6) return
    onChange(people + 1)
  }
  const lessPeople = () => {
    if (people <= 1) return
    onChange(people - 1)
  }

  return (
    <div className={s.guests}>
      <span className={s.guestsLabel}>Nb de personnes</span>
      <div className={s.guestsCounter}>
        <button className={classNames(s.guestsLess, people === 1 && s.guestsLessDisabled)} onClick={lessPeople}>
          -
        </button>
        <span className={s.guestsValue}>{people}</span>
        <button className={s.guestsMore} onClick={morePeople}>
          +
        </button>
      </div>
    </div>
  )
}

export const RoomPrices = ({ rooms }) => {
  if (!rooms) return null
  if (rooms.length === 0) return null

  return (
    <div className={s.rooms}>
      {rooms.slice(0, 3).map((room, idx) => (
        <div key={idx} className={s.room}>
          <div className={s.roomLabel}>{room.label}</div>
          <div className={s.roomPrice}>
            <span className={s.roomPriceValue}>{room.priceLabel}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export const useHotelClickTagProps = ({ datesChanged, rooms }) => {
  const clickTagProps = useCommonGeoentityClickTagProps(PUB_TAG.PUB_FICHEPOI_REDIRECTIONRESERVATION)
  const N = datesChanged ? '' : 'N'
  const Z = !rooms || rooms.length === 0 ? '0' : ''

  // (FDNA --> bouton "réserver", dates non-modifiées ; FDA --> bouton "réserver", dates modifiées ; FDNA0 -->  bouton "voir toutes les disponibilités", dates non-modifiées ; FDA0 -->  bouton "voir toutes les disponibilités", dates modifiées)
  clickTagProps.tagInfo.Disponibilite = `FD${N}A${Z}`

  return clickTagProps
}

const GeoentityBlockContentWidget = props => {
  const id = useSelector(selectCurrentGeoentityId)
  const filterDates = useSelector(selectFilterHotelDates)
  const DEFAULT_FROM_DATE = filterDates ? filterDates.from : getFutureDateISO({ days: 30 })
  const DEFAULT_TO_DATE = filterDates ? filterDates.to : getFutureDateISO({ days: 31 })
  const [dates, setDates] = useState({ fromDate: DEFAULT_FROM_DATE, toDate: DEFAULT_TO_DATE })
  const [people, setPeople] = useState()
  const [widgetData, setWidgetData] = useState()
  const [datesChangedForTag, setDatesChangedForTag] = useState(false)

  const supportCapacity = props?.data?.params?.supportCapacity === 'true'
  const templatizedUrl = props?.data?.params?.templatizedUrl
  const reservationUrl = widgetData?.reservationUrl
  const rooms = widgetData?.rooms
  const url = reservationUrl || templatizedUrl

  const clickTagProps = useHotelClickTagProps({ rooms, datesChanged: datesChangedForTag })
  const currentTabId = useSelector(selectGeoentityCurrentTabId)
  const appConfig = useSelector(store => getMatchingConfig(store)(CONFIG_TYPES.application, currentTabId))
  const sendBiTagNow = useTagBiForGeoentity(SPD_GEOENTITY_LINK, { targeturl: url })

  useEffect(() => {
    const { fromDate, toDate } = dates
    updateRooms({ id, checkInDate: fromDate, checkOutDate: toDate, people }, setWidgetData)
  }, [dates, people])

  const onDateChange = ({ fromDate, toDate }) => {
    setDatesChangedForTag(true)
    setDates({ fromDate, toDate })
  }

  return (
    <div>
      <div className={s.title}>
        <span className={s.titleBook}>Réservation avec</span>
        <img className={s.titleLogo} src={appConfig?.banner} />
      </div>
      <div className={s.dateInputs}>
        <DatesPickerHotel
          fromDateLabel={'Arrivée'}
          toDateLabel={'Départ'}
          currentFromDate={dates.fromDate}
          currentToDate={dates.toDate}
          onDateChange={onDateChange}
        />
      </div>
      {supportCapacity && <PeopleForm people={people} onChange={value => setPeople(value)} />}
      <RoomPrices rooms={rooms} />
      {url && (
        <div className={s.ctaButton}>
          <RectangleActionButton
            color={COLOR_ORANGE_EMPTY}
            href={url}
            targetBlank={true}
            nofollow={true}
            tagData={{ ...clickTagProps, shouldTagImpression: true }}
            onClick={() => {
              sendBiTagNow()
            }}
            label={rooms && rooms.length > 0 ? 'Réserver' : 'Voir plus de disponibilités'}
          />
        </div>
      )}
    </div>
  )
}

export default GeoentityBlockContentWidget
